import { Outlet } from 'react-router-dom';

/**
 * AuthLayout — a nested layout route that constrains its content to the
 * `max-w-md` auth card width. It composes UNDER the AppLayout `centered`
 * variant (which owns the centering + globe z-10 lift), so this layout is
 * responsible ONLY for the card width and is the composition seam for any
 * future auth-only chrome. It renders an `<Outlet />` for the auth pages
 * mounted beneath it.
 *
 * GW-10515: reintroduced (after being retired in GW-10437) as the composable
 * home for the card width now that the generic `centered` variant owns the
 * reusable centering/z-index. The globe/z-index stays PURELY a layout concern
 * on the `centered` variant — auth page components reference neither.
 */
export function AuthLayout() {
  return (
    <div className="w-full max-w-md">
      <Outlet />
    </div>
  );
}
